<template>
  <b-modal
    @close="onClose"
    :full-screen="isFullScreen"
    :active.sync="opened"
    width="500px"
  >
    <div class="card">
      <div class="card-content">
        <div class="section-block">
          <span class="title">FORGOT PASSWORD</span>
        </div>

        <p class="tw-mb-4">
          Enter your Email Address to receive an email with a link to reset your
          password.
        </p>

        <validation-observer
          ref="passwordResetEmail"
          tag="form"
          @submit.prevent="sendResetCode"
          v-slot="{ valid }"
        >
          <validation-provider
            name="email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <b-field :message="errors" :type="{ 'is-danger': errors.length }">
              <b-input
                v-model="form.email"
                placeholder="Email Address"
                type="email"
              ></b-input>
            </b-field>
          </validation-provider>

          <div class="level">
            <div class="level-left">
              <router-link
                class="is-family-secondary is-size-6"
                :to="{ name: 'login' }"
                >Login</router-link
              >
            </div>
            <div class="level-right">
              <b-button
                :disabled="!valid || isSubmitting"
                :loading="isSubmitting"
                native-type="submit"
                type="is-primary"
                >Send Password Reset Code</b-button
              >
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ModalMixin from '@/utils/mixins/modal'

export default {
  mixins: [ModalMixin],
  metaInfo: {
    title: 'Forgot Password'
  },
  data() {
    return {
      opened: true,
      isSubmitting: false,
      form: {
        email: ''
      }
    }
  },
  methods: {
    onClose() {
      this.$router.push({ name: 'home' })
    },
    sendResetCode() {
      this.isSubmitting = true
      this.$api
        .post('/auth/forgot-password', this.form)
        .then(() => {
          this.$router.push({ name: 'password.reset' })
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.passwordResetEmail.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>
